const formatDate = (date) => {
  const year = String(date.getFullYear());
  let month = String(1 + date.getMonth()).padStart(2, "0");
  let day = String(date.getDate()).padStart(2, "0");

  return `${month}.${day}.${year}`;
};

export default formatDate;
